import api from './axios';

export const userApi = {
  updateProfile: (payload) => api.patch('provider/profile', payload).then((r) => r.data),
  getReviews: (userId) => api.get(`/users/${userId}/reviews`).then((r) => r.data),
  updateServices: (payload) => api.patch('/provider/services', payload).then((r) => r.data),
  updateServiceArea: (payload) => api.patch('/provider/service-area', payload).then((r) => r.data),
  updateAvailability: (payload) => api.patch('/provider/availability', payload).then((r) => r.data),
  completeOnboarding: (payload) => api.patch('/provider/onboarding', payload).then((r) => r.data),
};